import { useParams } from 'react-router-dom';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { LabelValue } from 'apps/shared/scripts/components';
import { useCardById } from 'apps/shared/scripts/graphql';
import { formatDate } from 'apps/shared/scripts/utils';

import { cardStatsClassName, labelClassName, valueClassName } from './styles';

const CardStats = () => {
  const { cardId } = useParams();

  const { card, isLoading } = useCardById({ variables: { id: cardId! } });

  return (
    <div className={cardStatsClassName}>
      <ContentCard>
        <LabelValue
          labelClassName={labelClassName}
          valueClassName={valueClassName}
          label="Created on"
          value={isLoading || !card ? '' : formatDate(card.createdAt)}
        />
      </ContentCard>
      <ContentCard noSpacing>
        <LabelValue
          labelClassName={labelClassName}
          valueClassName={valueClassName}
          label="Posts"
          value={isLoading || !card ? 0 : card.postCount}
        />
      </ContentCard>
    </div>
  );
};

CardStats.displayName = 'CardStats';

export default CardStats;
